import type { JSX } from "react";
import type { SessionCompletedEvent } from "../api/types";

interface CompletePageProps {
  title: string;
  completion: SessionCompletedEvent;
  onPlayAgain: () => void;
  onLogout: () => void;
}

/** Shows the final score and debrief with frozen source links. */
export function CompletePage({
  title,
  completion,
  onPlayAgain,
  onLogout,
}: CompletePageProps): JSX.Element {
  return (
    <main className="page complete-page">
      <header className="toolbar">
        <div>
          <p className="eyebrow">{title}</p>
          <h1>Caset er løst</h1>
        </div>
        <button type="button" className="secondary" onClick={onLogout}>Logg ut</button>
      </header>

      <p className="final-score">Poeng: {completion.score} av 100</p>
      <section aria-labelledby="debrief-heading">
        <h2 id="debrief-heading">Faglig oppsummering</h2>
        <p>{completion.debrief.summary}</p>
        <h3>Rettslig grunnlag</h3>
        <p>{completion.debrief.legalBasis}</p>
      </section>

      <section aria-labelledby="sources-heading">
        <h2 id="sources-heading">Kilder</h2>
        <ul className="source-list">
          {completion.debrief.sources.map((source) => (
            <li key={source.documentId}>
              <a href={source.url} rel="noreferrer" target="_blank">{source.title}</a>
              <blockquote>{source.excerpt}</blockquote>
            </li>
          ))}
        </ul>
      </section>

      <button type="button" onClick={onPlayAgain}>Spill et nytt case</button>
    </main>
  );
}
